<template>
  <Menubar :model="items">
  </Menubar>
</template>

<script>
import Menubar from 'primevue/menubar'
import { StorageService } from '@/services/storage.service'
import StorageConstants from '@/constants/storage.constants'
import AuthConstants from '@/constants/auth.constants'
import ApiService from '@/services/api.service'

export default {
  data () {
    return {
      username: '',
      loginApiStatus: StorageService.get(StorageConstants.LoginStatusApiKey) || ''
    }
  },
  name: 'UserSection',
  components: {
    Menubar
  },
  mounted () {
    this.fetchUserData()
  },
  methods: {
    handleLogin () {
      this.$router.push({ name: 'Login' })
    },
    handleLogout () {
      StorageService.save(StorageConstants.LoginStatusApiKey, AuthConstants.LoginApiStatusLogout)
      StorageService.remove(StorageConstants.Email)
      ApiService.post('/auth/logout')

      this.$router.push({ name: 'Dashboard' })
        .then(() => {
          window.location.reload()
        })
    },
    fetchUserData () {
      this.username = ''
    }
  },
  computed: {
    isLoggedIn () {
      return this.loginApiStatus === 'success'
    },
    items () {
      if (this.isLoggedIn) {
        return [
          {
            label: 'Hello ' + this.username,
            icon: 'pi pi-fw pi-user',
            items: [
              // {
              //   label: 'Dashboard',
              //   icon: 'pi pi-fw pi-home',
              //   command: () => this.$router.push({ name: 'UserDashboard' })
              // },
              {
                label: 'Subscription',
                icon: 'pi pi-fw pi-credit-card',
                command: () => this.$router.push({ name: 'UserSubscription' })
              },
              {
                label: 'Logout',
                icon: 'pi pi-fw pi-sign-out',
                command: () => this.handleLogout()
              }
            ]
          }
        ]
      } else {
        return [
          {
            label: 'Login',
            icon: 'pi pi-fw pi-sign-in',
            command: () => this.handleLogin()
          }
        ]
      }
    }
  }
}
</script>

<style>
.p-menubar {
  border: none;
  background: none;
  padding: 8px;
  margin-right: 16px;
  color: #495057;
}

.p-menuitem-link {
  padding: .75rem 1rem;
  color: #495057;
  border-radius: 3px;
  transition: box-shadow .2s;
  -webkit-user-select: none;
  -moz-user-select: none;
  user-select: none;
}

.p-menuitem-icon {
  margin-right: 8px;
}

.image-item {
  display: flex;
  align-items: center;
}

.image-item img {
  width: 40px;
  height: 40px;
  border-radius: 50%;
}

.image-item span {
  margin-left: 8px;
}
</style>
